import { useState, useEffect } from "react";
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

import LibraryPage from "@/features/Library/page/library-page";

import SearchPage from "../Modules/SearchPage";
import GoogleAuthRedirect from "../Modules/GoogleAuthRedirect";
import GmailAuthRedirect from "../Modules/GmailAuthRedirect";
import GoogleCalendarRedirect from "../Modules/GoogleCalendarRedirect";
import QuickBooksAuthRedirect from "../Modules/QuickBooksAuthRedirect";
import OutlookAuthRedirect from "../Modules/OutlookAuthRedirect";
import LoginPage from "../Modules/LoginPage";
import FirmLoginPage from "../Modules/FirmLoginPage";
import LandingPage from "../Modules/LandingPage";
import { getCaseId, getClientId, getToken } from "../Utils/helper";
import InboxPage from "../Modules/InboxPage";
import CostPage from "../Modules/CostPage";
import AccidentPage from "../Modules/AccidentPage";
import ToDoPage from "../Modules/ToDoPage";
// import CarDetailsModal from "../Components/Modals/CarDetailsModal.js";
// import VehicleLocationModal from "../Components/Modals/VehicleLocationModal.js";
import InactivityModal from "../Components/Modals/inactivityModal.js";
// import VehicleDescriptionModal from "../Components/Modals/VehicleDescriptionModal.js";
import DocumentModal from "../Components/DocumentModal";
import PhotoDocumentModal from "../Components/PhotoDocumentModal/index";
import { LibraryDocumentViewerProvider } from "../features/Library/context/LibraryDocumentViewerContext";
import LibraryDocumentViewer from "../features/Library/components/LibraryDocumentViewer/LibraryDocumentViewer";
import { fetchCurrentClient } from "../Redux/client/clientSlice";
import {
  fetchAllPages,
  fetchAllStages,
  fetchCommutativeChecklist,
  fetchCurrentCase,
} from "../Redux/caseData/caseDataSlice";
import CourtForm from "../Modules/CourtForm";
import { getToDoCountAPI, markReadToDoItemsAPI, fetchUserPreferences } from "../Providers/main";
import TreatmentPage from "../Modules/TreatmentPage";
import WorkListPage from "../Modules/WorkListPage";
import LitigationPage from "../Modules/LitigationsPage";
import Calendar from "../Components/Calendar/Calendar";
import NotesSectionPage from "../Modules/NotesSectionPage";
import LawFirmDirectory from "../Modules/LawFirmDirectory";
import FlaggedCasesPage from "../Modules/FlaggedCasesPage";
import { setToDoCount } from "../Redux/general/actions";
import TimePage from "../Modules/TimePage";
import HomePage from "../Components/Home/HomePage";
import EmploymentPage from "../Modules/EmploymentPage";
import ESignPage from "../Components/DocumentModal/DocumentSideBar/ESignPage";
import { DocumentModalProvider } from "../Components/common/CustomModal/CustomModalContext";
import FirmSetting from "../Modules/FirmSettingsPage";
import WordProcessor from "../Modules/WordProcessor";
import AssembleDocumentModal from "../Components/AssembleDocumentModal";
import { InactivityProvider } from "../Providers/inactivity";
import SettlementPage from "../Modules/SettlementPage";
import GoogleDriveRedirect from "../Modules/GoogleDriveRedirect";
import DropboxRedirect from "../Modules/DropboxRedirect";
import BoxRedirect from "../Modules/BoxRedirect";
import MsAuthRedirect from "../Modules/MsAuthRedirect";
import MsCalendarRedirect from "../Modules/MsCalendarRedirect";
import MsOneDriveRedirect from "../Modules/MsOneDriveRedirect";
import SvgDefs from "../Components/BP/modals/CaseProviderModals/SvgDefs";
import OtherPartiesPage from "../Modules/OtherPartiesPage";
import GmailOAuthHandler from "../Components/FirmSettings/client-communication/login-callbacks/gmail-callback";
import OutlookOAuthHandler from "../Components/FirmSettings/client-communication/login-callbacks/outlook-callback";
import CreateSignupScreen from "../Modules/CreateSignupScreen";
import CreateClientPag from "../Modules/CreateClientPage";
import AccessValidationProvider from "../Providers/ProtectedRoute";
import NewClientPage from "../Modules/NewClientPage";
import WitnessesPage from "../Modules/WitnessesPage";
import NewReportPage from "../Modules/NewReportPage";
import ExpertsPage2 from "../Modules/ExpertsPage2";
import NewInjuryPage from "../Modules/NewInjuryPage";
import NewDocPage from "../Modules/NewDocPage";
import DefendantPage from "../Modules/DefendantPage";
import NewPhotoPage from "../Modules/NewPhotoPage";
import NewChatPage from "../Modules/NewChatPage2";
import NewChecklistPage from "../Modules/NewChecklistPage";
import NewCaseNavigatorPage from "../Modules/NewCaseNavigatorPage";
import NewCasePage from "../Modules/NewCasePage";
import NewInsurancePage from "../Modules/NewInsurancePage";
import wsManager from "../Utils/websocket-manager";
import DogBitePage from "../Modules/DogBitePage";
import WrongfulDeathPage from "../Modules/WrongfulDeathPage";
import PropertyDamage from "../Modules/PropertyDamage";
import NewCoPilotPage from "../Modules/NewCoPilotPage";
import DraftsPage from "../Modules/DraftsPage";
import NewCaseLoansPage from "../Modules/NewCaseLoansPage";
import NewLitigationCentralPage from "../Modules/NewLitigationCentralPage";
import GoogleAuthCallback from "../Components/FirmSettings/cloud-storage/googleauthCallback";
import OneDriveAuthCallback from "../Components/FirmSettings/cloud-storage/onedriveCallback";
import DropboxAuthCallback from "../Components/FirmSettings/cloud-storage/dropboxCallback";
import BoxAuthCallback from "../Components/FirmSettings/cloud-storage/boxAuthCallback";
import { BrandColorProvider } from "../Providers/brandColor";
import MediationORSettleConf from "../Modules/MediationOrSettleConf";
import SettleConf from "../Modules/SettlementConference";
import AccountingNewPage from "../Modules/AccountingNewPage";
import FirmReportingPage from "../Modules/FirmReportingPage";
import RecordingPage from "../Modules/RecordingPage";
import EditCaseTypeDateModal from "../Components/EditCaseTypeDateModal";
import CounselPage from "../Modules/CounselPage.js";
import TodosCountBridge from "../Components/Sidebars/TodosCountBridge";
import WorklistCountBridge from "../Components/Sidebars/WorklistCountBirdge";
import FlaggedCaseCountBridge from "../features/flaggedCases/FlaggedCaseCountBridge";
import ScoreBoard from "../Modules/ScoreBoard";
import NewCaseHourlyPage from "../Modules/NewCaseHourlyPage";
import NewClientHourlyPage from "../Modules/NewClientHourlyPage";
import ClientDocumentTitle from "../Components/common/ClientDocumentTitle";
import FirmUserChatProvider from "../contexts/FirmUserChatProvider";

import CaseTypeRouteGuard from "./CaseTypeRouteGuard";
import { FIRM_SETTINGS_PATH, isFirmSettingsRoute } from "./routeAccessPolicy.mjs";

const LegacyFirmSettingsRedirect = () => {
  const location = useLocation();
  return <Navigate replace to={`${FIRM_SETTINGS_PATH}${location.search}`} />;
};

const getIdsFromUrl = () => {
  const parts = window.location.pathname.split("/").filter(Boolean);
  // ["bp-case", "116", "115"]
  return {
    clientId: parts[1],
    caseId: parts[2],
  };
};

const hasUsableId = (value) =>
  value !== undefined &&
  value !== null &&
  value !== "" &&
  value !== "undefined" &&
  value !== "null";

const Main = () => {
  const dispatch = useDispatch();

  // Token values rotate during refresh. Route/data bootstrap should only run
  // when the session crosses the signed-in boundary.
  const [isAuthenticated, setIsAuthenticated] = useState(Boolean(getToken()));

  useEffect(() => {
    const handleTokenChange = () => {
      setIsAuthenticated(Boolean(getToken()));
    };

    setIsAuthenticated(Boolean(getToken()));

    window.addEventListener("auth-token-changed", handleTokenChange);
    return () => window.removeEventListener("auth-token-changed", handleTokenChange);
  }, []);

  // const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";
  // const urlObj = new URL(backendUrl);
  // const isSecure = urlObj.protocol === "https:";
  // const wsProtocol = isSecure ? "wss:" : "ws:";
  // const wsHost = urlObj.host;
  // const wsUrl = `${wsProtocol}//${wsHost}/ws/todo/?username=${localStorage.getItem("username")}`;
  // const { lastMessage: lastMessageToDo } = useWebSocket(wsUrl, {
  //   share: false,
  //   shouldReconnect: () => true,
  // });

  useEffect(() => {
    if (!isAuthenticated) return;

    // Connect WebSocket if not already connected
    wsManager.connect().catch((err) => {
      console.error("WS connection error:", err);
    });

    return () => {
      // OPTIONAL: If you want WS to stay alive even when switching pages,
      // DO NOT disconnect here.
      // Only disconnect on logout.
    };
  }, [isAuthenticated]);

  useEffect(() => {
    getToDoCountAPI(dispatch, setToDoCount);

    if (window.location.href.includes("work-list")) {
      markReadToDoItemsAPI(dispatch, setToDoCount);
    }
  }, [dispatch]);

  useEffect(() => {
    const storedClientId = getClientId();
    const storedCaseId = getCaseId();
    const { clientId: urlClientId, caseId: urlCaseId } = getIdsFromUrl();
    const useUrlCaseContext = !isFirmSettingsRoute(window.location.pathname);
    if (!isAuthenticated) return;

    fetchUserPreferences();

    const hasUrlPair = useUrlCaseContext && hasUsableId(urlClientId) && hasUsableId(urlCaseId);
    const hasStoredPair = hasUsableId(storedClientId) && hasUsableId(storedCaseId);
    if (!hasUrlPair && !hasStoredPair) return;

    const clientId = hasUrlPair ? urlClientId : storedClientId;
    const caseId = hasUrlPair ? urlCaseId : storedCaseId;
    dispatch(fetchCurrentClient(clientId));
    dispatch(fetchCurrentCase(clientId, caseId));
    dispatch(fetchAllPages(caseId));
    dispatch(fetchAllStages());
    dispatch(fetchCommutativeChecklist(clientId, caseId));
  }, [isAuthenticated]);

  useEffect(() => {
    const handleUnload = () => {
      const [navigation] = performance.getEntriesByType("navigation");

      if (navigation && navigation.type !== "reload") {
        return "logout";
      }
    };

    window.addEventListener("unload", handleUnload);

    return () => {
      window.removeEventListener("unload", handleUnload);
    };
  }, []);

  const loggedInRoutes = [
    <Route key="inbox-page-main" path={"/inbox/:clientId/:caseId"} element={<InboxPage />} />,
    <Route key="library-page" path={"/bp-library/:clientId/:caseId"} element={<LibraryPage />} />,
    <Route key="client-page" path={"/bp-client/:clientId/:caseId"} element={<NewClientPage />} />,
    <Route
      key="client-hourly-page"
      path={"/bp-client-hourly/:clientId/:caseId"}
      element={<NewClientHourlyPage />}
    />,
    <Route
      key="client-recordings"
      path={"/bp-recordings/:clientId/:caseId"}
      element={<RecordingPage />}
    />,
    <Route key="drafts-page" path={"/bp-drafts/:clientId/:caseId"} element={<DraftsPage />} />,

    <Route
      key="mediation-settle"
      path={"/bp-mediation/:clientId/:caseId"}
      element={<MediationORSettleConf />}
    />,
    <Route
      key="settle-conf"
      path={"/bp-settleConferences/:clientId/:caseId"}
      element={<SettleConf />}
    />,

    <Route
      key="property-damage"
      path={"/bp-propertydamage/:clientId/:caseId"}
      element={<PropertyDamage />}
    />,

    <Route
      key="create-client"
      path={"/create-client/:clientId/:caseId"}
      element={<CreateClientPag />}
    />,
    <Route key="todo-page" path={"/bp-todo/:clientId/:caseId"} element={<ToDoPage />} />,
    <Route key="worklist" path={"/work-list/:clientId/:caseId"} element={<WorkListPage />} />,
    <Route
      key="injuries-page"
      path={"/bp-injuriessub/:clientId/:caseId"}
      element={<NewInjuryPage />}
    />,
    <Route
      key="witness-page"
      path={"/bp-witnesses/:clientId/:caseId"}
      element={<WitnessesPage />}
    />,
    <Route key="case-page2" path={"/bp-case/:clientId/:caseId"} element={<NewCasePage />} />,
    <Route
      key="case-hourly-page"
      path={"/bp-case-hourly/:clientId/:caseId"}
      element={<NewCaseHourlyPage />}
    />,
    <Route key="cost-page-2" path={"/bp-costs/:clientId/:caseId"} element={<CostPage />} />,
    <Route key="chat-page2" path={"/chat/:clientId/:caseId"} element={<NewChatPage />} />,

    <Route
      key="flaggedcases-page"
      path={"/bp-flaggedcases/:clientId/:caseId"}
      element={<FlaggedCasesPage />}
    />,
    <Route
      key="accident-page"
      path={"/bp-caraccident/:clientId/:caseId"}
      element={<AccidentPage />}
    />,
    <Route key="dog-bite-page" path={"/bp-dogbite/:clientId/:caseId"} element={<DogBitePage />} />,
    <Route
      key="wrong-death-page"
      path={"/bp-wrongdeath/:clientId/:caseId"}
      element={<WrongfulDeathPage />}
    />,

    <Route key="treamtment-page" path="/treatment/" element={<TreatmentPage />} />,

    <Route key="counsel-page" path={"/bp-counsel/:clientId/:caseId"} element={<CounselPage />} />,
    <Route
      key="insurance-page"
      path={"/bp-insurance/:clientId/:caseId"}
      element={<NewInsurancePage />}
    />,

    <Route key="search-page" path={"/search/"} element={<SearchPage />} />,
    <Route key="note-page" path={"/bp-note/:clientId/:caseId"} element={<NotesSectionPage />} />,
    <Route
      key="directory-page"
      path={"/bp-lawfirmdirectory/:clientId/:caseId"}
      element={<LawFirmDirectory />}
    />,
    <Route
      key="employment-page"
      path={"bp-employment/:clientId/:caseId"}
      element={<EmploymentPage />}
    />,
    <Route key="reports-page" path={"/bp-reports/:clientId/:caseId"} element={<NewReportPage />} />,
    <Route
      key="firmReporting-page"
      path={"/bp-firmReporting/:clientId/:caseId"}
      element={<FirmReportingPage />}
    />,
    <Route key="photos-page2" path={"/bp-photo/:clientId/:caseId"} element={<NewPhotoPage />} />,
    <Route
      key="documents-page2"
      path={"/bp-documents/:clientId/:caseId"}
      element={<NewDocPage />}
    />,

    <Route
      key="navigator-page2"
      path={"/bp-navigator/:clientId/:caseId"}
      element={<NewCaseNavigatorPage />}
    />,
    <Route
      key="defendants-page"
      path={"/bp-defendants/:clientId/:caseId"}
      element={<DefendantPage />}
    />,
    <Route
      key="checklists-page-2"
      path={"/bp-checkLists/:clientId/:caseId"}
      element={<NewChecklistPage />}
    />,
    <Route key="experts-page" path={"/bp-experts/:clientId/:caseId"} element={<ExpertsPage2 />} />,
    <Route key="calender-page" path={"/bp-calendar/:clientId/:caseId"} element={<Calendar />} />,
    <Route
      key="litigation-page"
      path={"/bp-litigation/:clientId/:caseId"}
      element={<LitigationPage />}
    />,
    <Route key="time-page" path={"/bp-timePage/:clientId/:caseId"} element={<TimePage />} />,
    <Route key="bp-home" path={"/bp-home/:clientId/:caseId"} element={<HomePage />} />,
    <Route
      key="esign-template-edit-page"
      path={"/esign/:clientId/:caseId/template/:templateId"}
      element={<ESignPage />}
    />,
    <Route
      key="esign-page"
      path={"/esign/:clientId/:caseId/:docId/:templateId?"}
      element={<ESignPage />}
    />,
    <Route key="firm-settings" path={FIRM_SETTINGS_PATH} element={<FirmSetting />} />,
    <Route
      key="firm-settings-legacy"
      path={`${FIRM_SETTINGS_PATH}/:clientId/:caseId`}
      element={<LegacyFirmSettingsRedirect />}
    />,
    <Route key="scoreboard" path={"/bp-scoreboard/"} element={<ScoreBoard />} />,
    <Route path="/auth/google/callback" element={<GoogleAuthCallback />} />,
    <Route path="/auth/onedrive/callback" element={<OneDriveAuthCallback />} />,
    <Route path="/auth/dropbox/callback" element={<DropboxAuthCallback />} />,
    <Route path="/auth/box/callback" element={<BoxAuthCallback />} />,
    <Route
      key="wordprocessor"
      path={"/bp-wordprocessor/:clientId/:caseId/*"}
      element={<WordProcessor />}
    />,
    <Route
      key="copilot-page2"
      path={"/bp-copilot/:clientId/:caseId"}
      element={<NewCoPilotPage />}
    />,
    <Route key="court-forms" path={"/bp-courtform/:clientId/:caseId"} element={<CourtForm />} />,
    <Route
      key="settlement-page"
      path={"/bp-settlement/:clientId/:caseId"}
      element={<SettlementPage />}
    />,
    <Route
      key="accounts-page2"
      path={"/bp-accounting/:clientId/:caseId"}
      element={<AccountingNewPage />}
    />,
    <Route
      key="caseloan-page"
      path={"/bp-caseloan/:clientId/:caseId"}
      element={<NewCaseLoansPage />}
    />,
    <Route
      key="other-parties"
      path={"/bp-otherparties/:clientId/:caseId"}
      element={<OtherPartiesPage />}
    />,
    <Route
      key="litigation-central2"
      path={"/bp-litigationCentral/:clientId/:caseId"}
      element={<NewLitigationCentralPage />}
    />,
    <Route path="/gmail-oauth2callback" element={<GmailOAuthHandler />} />,
    <Route path="/outlook-oauth2callback" element={<OutlookOAuthHandler />} />,
  ];

  //
  return (
    <>
      <Router>
        <ClientDocumentTitle isAuthenticated={isAuthenticated} />
        <FirmUserChatProvider>
          <BrandColorProvider>
            <AccessValidationProvider>
              <InactivityProvider>
                <SvgDefs />
                <TodosCountBridge />
                <WorklistCountBridge />
                <FlaggedCaseCountBridge isAuthenticated={isAuthenticated} />
                <InactivityModal />
                {/* <VehicleLocationModal />
                <CarDetailsModal />
                <VehicleDescriptionModal /> */}
                <EditCaseTypeDateModal />
                {/* <AttachUserModal /> */}
                <DocumentModalProvider>
                  <LibraryDocumentViewerProvider>
                    <DocumentModal />
                    <PhotoDocumentModal />
                    <AssembleDocumentModal />
                    <LibraryDocumentViewer />

                    <Routes>
                      <Route path="/landing-page" element={<LandingPage />} />
                      <Route path="/login" element={<LoginPage />} />
                      <Route
                        path="/api/treatment-opt/activate-account"
                        element={<CreateSignupScreen />}
                      />
                      <Route
                        path="/"
                        element={
                          isAuthenticated ? <Navigate replace to="/search/" /> : <LoginPage />
                        }
                      />
                      <Route
                        key="bp-google-redirect-with-auth"
                        path={"/google_redirect_with_auth/"}
                        element={<GoogleAuthRedirect />}
                      />
                      <Route
                        key="bp-gmail-redirect-with-auth"
                        path={"/gmail_redirect_with_auth/"}
                        element={<GmailAuthRedirect />}
                      />
                      <Route
                        key="bp-outlook-redirect-with-auth"
                        path={"/outlook_redirect_with_auth/"}
                        element={<OutlookAuthRedirect />}
                      />
                      <Route
                        key="bp-google-calendar-redirect"
                        path={"/google_calendar_redirect_with_auth/"}
                        element={<GoogleCalendarRedirect />}
                      />
                      <Route
                        key="bp-quickBooksRedirect"
                        path={"/quickBooksRedirect/"}
                        element={<QuickBooksAuthRedirect />}
                      />
                      <Route
                        key="bp-google-drive-redirect"
                        path={"/google_drive_redirect/"}
                        element={<GoogleDriveRedirect />}
                      />
                      <Route
                        key="bp-box-redirect"
                        path={"/box_redirect/"}
                        element={<BoxRedirect />}
                      />
                      <Route
                        key="bp-dropbox-redirect"
                        path={"/dropbox_redirect/"}
                        element={<DropboxRedirect />}
                      />
                      <Route
                        key="bp-ms-auth-redirect"
                        path={"/msRedirect/"}
                        element={<MsAuthRedirect />}
                      />
                      <Route
                        key="bp-ms-calendar-redirect"
                        path={"/msCalendarRedirect/"}
                        element={<MsCalendarRedirect />}
                      />
                      <Route
                        key="bp-ms-onedrive-redirect"
                        path={"/msOneDriveRedirect/"}
                        element={<MsOneDriveRedirect />}
                      />
                      {isAuthenticated && (
                        <Route element={<CaseTypeRouteGuard />}>{loggedInRoutes}</Route>
                      )}
                      <Route path="/:firmSlug" element={<FirmLoginPage />} />
                      <Route
                        path="*"
                        element={
                          isAuthenticated ? <Navigate replace to="/search/" /> : <LoginPage />
                        }
                      />
                    </Routes>
                  </LibraryDocumentViewerProvider>
                </DocumentModalProvider>
              </InactivityProvider>
            </AccessValidationProvider>
          </BrandColorProvider>
        </FirmUserChatProvider>
      </Router>
    </>
  );
};

export default Main;
